export default __webpack_public_path__ + "static/media/iconeDesempenhoMaior.6d1693e7.png";